export enum NotificationIntervals {
  ThirtyDays = 30,
  SevenDays = 7,
  ZeroDays = 0,
}
